const PAYMENT_FAILED_STATUSES = new Set(["past_due", "unpaid"]);

/** Admin-invited tester accounts — treated like paid subscribers for feature gates. */
export function isTesterUser(user) {
  return user?.is_tester === true || user?.subscriptionStatus === "admin_invited";
}

/** Active paid, trialing, or invited tester. */
export function hasPremiumFeatureAccess(user) {
  if (!user) return false;
  if (isTesterUser(user)) return true;
  const status = user.subscriptionStatus;
  return status === "active" || status === "trialing";
}

/** Max documents attachable per query/run (2 for paid or tester, 1 otherwise). */
export function getMaxFilesPerQuery(user) {
  if (!user) return 1;
  if (isTesterUser(user) || user.subscriptionStatus === "active") return 2;
  return 1;
}

export function isInPaymentGracePeriod(user) {
  if (!user || user.subscriptionStatus !== "past_due") return false;
  const until =
    user.subscriptionAccessUntil ||
    user.subscription?.subscriptionAccessUntil;
  if (!until) return false;
  return new Date() < new Date(until);
}

export function shouldBlockSubscriptionAccess(user) {
  if (!user || user.is_tester) return false;
  if (user.subscriptionStatus === "unpaid") return true;
  if (user.subscriptionStatus === "past_due") {
    if (isInPaymentGracePeriod(user)) return false;
    return true;
  }
  return false;
}

/** @deprecated Use shouldBlockSubscriptionAccess for access gates */
export function isSubscriptionPaymentBlocked(user) {
  return shouldBlockSubscriptionAccess(user);
}

export function isSubscriptionPaymentWarning(user) {
  if (!user || user.is_tester) return false;
  return (
    user.subscriptionStatus === "past_due" && isInPaymentGracePeriod(user)
  );
}

export function getSubscriptionPaymentMessage(user, subscription) {
  const merged = subscription
    ? { ...user, subscriptionStatus: subscription.subscriptionStatus ?? user?.subscriptionStatus, subscriptionAccessUntil: subscription.subscriptionAccessUntil ?? user?.subscriptionAccessUntil }
    : user;
  if (shouldBlockSubscriptionAccess(merged)) {
    return "Subscription suspended — update your payment method to restore access.";
  }
  if (isSubscriptionPaymentWarning(merged)) {
    return "Payment failed — update billing to avoid losing access.";
  }
  return null;
}
